<template>
  <div id="my-ideas" class="page">
    <div class="page-header">
      <page-title v-bind:title="pageTitle"></page-title>
      <i class="icon-search" @click="openSearch()"></i>
    </div>
    <search-bar
      v-if="countIdeas && countIdeas.aggregate.count > 0"
      :eventName="'update-search-text-my-ideas'"
    ></search-bar>

    <div class="categories">
      <category-filter
        v-if="categories"
        label="Categories"
        v-model="categories"
        ref="categoryFilter"
      ></category-filter>
    </div>
    <div v-if="!isEmpty" class="my-ideas-list">
      <idea-of-the-day
        v-if="ideaOfTheDay && ideaOfTheDay.idea_of_the_day && !hideIdeaOfTheDay"
        :idea="ideaOfTheDay.idea_of_the_day"
        :id="ideaOfTheDay.idea_of_the_day.id"
      ></idea-of-the-day>
      <new-idea v-if="newIdeaModeActive"></new-idea>
      <idea-list v-if="ideas && ideas.length" v-bind:ideaList.sync="ideas"></idea-list>
      <add-button
        v-bind:act="displayNewIdea"
        :title="'Create new idea'"
      ></add-button>
    </div>

    <empty-state
      v-if="isEmpty"
      v-bind:callToAction="callToAction"
      v-bind:image="emptyStateImage"
      v-bind:description="emptyStateDescription"
      v-bind:act="createFirstIdea"
      v-bind:primary="true"
    ></empty-state>

    <empty-state
      v-if="isEmptySearch"
      v-bind:callToAction="'Show all my ideas'"
      v-bind:image="'undraw_empty_street.svg'"
      v-bind:description="'Oops... there are no ideas for this search 😢'"
      v-bind:act="resetSearchFromEmptyState"
      v-bind:primary="true"
    ></empty-state>
  </div>
</template>

<script>
import NewIdea from "../components/NewIdea.vue";
import IdeaList from "../components/IdeaList.vue";
import EmptyState from "../components/EmptyState.vue";
import PageTitle from "../components/PageTitle.vue";
import AddButton from "../components/AddButton.vue";
import SearchBar from "../components/shared/SearchBar.vue";
import CategoryFilter from "../components/ideas/CategoryFilter.vue";
import IdeaOfTheDay from "../components/ideas/IdeaOfTheDay.vue";
import bus from "../bus";
import messaging from "../messaging";

import getUserIdeas from "../gql/ideas/getUserIdeas.gql";
import countUserIdeas from "../gql/ideas/countUserIdeas.gql";
import updateIdeaOfTheDay from "../gql/ideas/updateIdeaOfTheDay.gql";
import getIdeaOfTheDay from "../gql/ideas/getIdeaOfTheDay.gql";

export default {
  components: {
    NewIdea,
    IdeaList,
    EmptyState,
    PageTitle,
    AddButton,
    SearchBar,
    CategoryFilter,
    IdeaOfTheDay,
  },
  data() {
    return {
      isEmpty: false,
      isEmptySearch: false,
      newIdeaModeActive: false,
      callToAction: "Create a new idea",
      emptyStateDescription:
        "It seems a bit empty in here. Why don’t you create an idea or two, so you won’t forget them? 😎",
      emptyStateImage: "undraw_blank_canvas.svg",
      pageTitle: "My Ideas",
      searchText: "",
      error: null,
      categories: [],
      hideIdeaOfTheDay: false,
    };
  },
  computed: {
    userIdFirebase() {
      return this.$store.state.userFirebase
        ? this.$store.state.userFirebase.uid
        : null;
    },
    userId() {
      return this.$store.state.user ? this.$store.state.user.id : null;
    },
    ideas() {
      if (this.ideasOriginal == undefined) return;
      let ideas = this.ideasOriginal;
      if(this.searchText && this.searchText.length) {
        ideas = ideas.filter(i => i.title.indexOf(this.searchText) > -1);
      }
      if(this.categories && this.categories.length) {

        const filterIdeasByCategories = function(idea, categories) {
          const ideaCategories = idea.categories.map(c => c.category.label);
          const searchCategories = categories.map(c => c.label);
          return ideaCategories.filter(c => searchCategories.includes(c)).length > 0;
        }
        
        ideas = ideas.filter(i => filterIdeasByCategories(i, this.categories))
      }
      bus.$emit("hide-loader");
      return ideas;
    },
  },
  apollo: {
    ideasOriginal: {
      query: getUserIdeas,
      variables() {
        return {
          userId: this.userId,
        };
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      },
      result() {  
        this.$nextTick(() => {
          bus.$emit("updateMyIdeas");
        });
      },
    },
    countIdeas: {
      query: countUserIdeas,
      variables() {
        return {
          userId: this.userId,
        };
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      },
    },
    ideaOfTheDay: {
      query: getIdeaOfTheDay,
      variables() {
        return {
          userId: this.userId,
        };
      },
      then() {},
      error() {},
    },
  },
  methods: {
    createFirstIdea: function() {
      this.isEmpty = false;
      this.isEmptySearch = false;
      this.newIdeaModeActive = true;
      this.focusNewIdeaInput();
    },
    addNewIdeaModeInactiveEvent: function() {
      bus.$on("new-idea-mode-inactive", () => {
        this.newIdeaModeActive = false;
        this.checkEmptyState();
        this.updateIdeas();
      });
    },
    focusNewIdeaInput: function() {
      setTimeout(() => {
        bus.$emit("focus-textarea");
      }, 100);
    },
    displayNewIdea: function() {
      this.newIdeaModeActive = true;
      this.isEmptySearch = false;
      this.resetSearchFromEmptyState();
      this.focusNewIdeaInput();
    },
    checkEmptyState: function() {
      if (!this.ideas || (this.ideas && this.ideas.length > 0)) {
        this.isEmpty = false;
        this.isEmptySearch = false;
      } else {
        if (this.countIdeas && this.countIdeas.aggregate.count > 0) {
          this.isEmpty = false;
          this.isEmptySearch = true;
        } else {
          this.isEmptySearch = false;
          this.isEmpty = true;
        }
      }
    },
    resetSearchFromEmptyState: function() {
      this.$emit("resetSearch");
      this.$refs.categoryFilter.resetSelectedCategories();
    },
    openSearch: function() {
      this.$emit("openSearch");
    },
    updateSearchTextEvent: function() {
      bus.$on("update-search-text-my-ideas", (searchTextNew) => {
        this.searchText = searchTextNew;
      });
    },
    updateIdeas: function() {
      this.$apollo.queries.ideasOriginal &&
        this.$apollo.queries.ideasOriginal.refetch();
    },
    updateIdeasEvent: function() {
      bus.$on("update-ideas", () => {
        this.updateIdeas();
      });
    },
    addHideIdeaEvent() {
      this.hideIdeaOfTheDay =
        localStorage.hideIdeaForToday == new Date().toLocaleDateString();
      bus.$on("hide-idea-of-the-day", () => {
        this.hideIdeaOfTheDay = true;
      });
    },
    hasOneDayPassed() {
      // get today's date. eg: "7/07/2007"
      const date = new Date().toLocaleDateString();

      // if there's a date in localstorage and it's equal to the above:
      // inferring a day has yet to pass since both dates are equal. 
      if (localStorage.lastSavedDate == date) return false;

      // this portion of logic occurs when a day has passed
      return true;
    },
    setIdeaOfTheDay() {
      if (!this.ideas || this.ideas.length < 10) {
        this.hideIdeaOfTheDay = true;
        return;
      } else {
        messaging && messaging.subscribe("idea_of_the_day");
      }

      if (!this.hasOneDayPassed()) return false;

      const randomIndex = Math.floor(Math.random() * this.ideas.length);
      const id = this.userId;
      const ideaId = this.ideas[randomIndex].id;

      this.$apollo
        .mutate({
          mutation: updateIdeaOfTheDay,
          variables: {
            id,
            ideaId,
          },
        })
        .then(() => {
          localStorage.lastSavedDate = (new Date()).toLocaleDateString();
          this.$apollo.queries.ideaOfTheDay.refetch();
        })
        .catch(function(error) {
          this.$rollbar.error(error);
        });
    },
  },
  beforeMount() {
    bus.$emit("show-loader", "");
    this.addHideIdeaEvent();
    this.addNewIdeaModeInactiveEvent();
    this.updateSearchTextEvent();
    this.updateIdeasEvent();
  },
  watch: {
    ideas: {
      immediate: true,
      handler: function() {
        this.checkEmptyState();
        this.setIdeaOfTheDay();
      },
    },
    countIdeas: {
      immediate: true,
      handler: function() {
        this.checkEmptyState();
      },
    },
  },
  updated() {
    bus.$emit("hide-loader");
  }
};
</script>

<style scoped lang="scss">
@use '../styles/theme.scss';

.my-ideas-list {
  margin-top: 20px;
}

.page-header {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-header .icon-search,
.page-header .page-title {
  display: inline;
}

.icon-search {
  cursor: pointer;
  font-size: 24px;
  margin-right: 45px;
  transform: scaleX(-1);
}

.search-bar {
  margin-top: 16px;
}

.categories {
  margin-top: 20px;
}

@media (min-width: 768px) {
  .page-header {
    justify-content: normal;
  }

  .icon-search {
    margin-left: 8px;
    margin-right: 0px;
  }

  .search-bar {
    margin-top: 24px;
  }
}
</style>
